class EnquiryModal {
  constructor() {
    this.modal = document.getElementById('EnquiryModal');
    this.overlay = document.getElementById('EnquiryModalOverlay');
    this.closeBtn = document.querySelector('.enquiry-modal__close');
    this.form = document.getElementById('enquiry-modal-form');
    this.successState = document.querySelector('.enquiry-modal__success');
    this.description = document.querySelector('.enquiry-modal__description');
    this.continueBtn = document.querySelector('.enquiry-modal__continue');
    this.errorMessage = document.querySelector('.enquiry-modal__error-message');
    this.botpoison = null;

    if (!this.modal || !this.overlay) return;

    this.init();
  }

  async init() {
    this.overlay.addEventListener('click', () => this.close());
    this.closeBtn?.addEventListener('click', () => this.close());
    this.continueBtn?.addEventListener('click', () => this.close());

    if (this.form && window.BOTPOISON_PUBLIC_KEY) {
      await this.initializeBotpoison();
      this.form.addEventListener('submit', (e) => this.handleSubmit(e));
    } else if (this.form) {
      this.form.addEventListener('submit', (e) =>
        this.handleSubmitWithoutBotpoison(e),
      );
    }
  }

  async initializeBotpoison() {
    try {
      await this.waitForBotpoison();
      this.botpoison = new Botpoison({
        publicKey: window.BOTPOISON_PUBLIC_KEY,
      });
    } catch (error) {
      console.error('Botpoison initialization failed:', error);
      this.handleBotpoisonFailure();
    }
  }

  waitForBotpoison() {
    return new Promise((resolve, reject) => {
      if (typeof Botpoison !== 'undefined') {
        resolve();
        return;
      }

      let attempts = 0;
      const maxAttempts = 50;

      const checkBotpoison = () => {
        if (typeof Botpoison !== 'undefined') {
          resolve();
        } else if (attempts < maxAttempts) {
          attempts++;
          setTimeout(checkBotpoison, 100);
        } else {
          reject(new Error('Botpoison failed to load'));
        }
      };

      checkBotpoison();
    });
  }

  async handleSubmit(e) {
    e.preventDefault();

    if (!this.form.checkValidity()) {
      this.form.reportValidity();
      return;
    }

    this.setLoadingState(true);
    this.hideError();

    try {
      const {solution} = await this.botpoison.challenge();
      const formData = new FormData(this.form);
      const formObject = Object.fromEntries(formData.entries());
      formObject._botpoison = solution;

      const actionURL = this.form.getAttribute('action');

      const response = await fetch(actionURL, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify(formObject),
      });

      if (response.ok) {
        this.showSuccess();
      } else {
        throw new Error(`HTTP ${response.status}: ${response.statusText}`);
      }
    } catch (error) {
      console.error('Form submission error:', error);
      this.showError();
    } finally {
      this.setLoadingState(false);
    }
  }

  async handleSubmitWithoutBotpoison(e) {
    e.preventDefault();

    if (!this.form.checkValidity()) {
      this.form.reportValidity();
      return;
    }

    this.setLoadingState(true);
    this.hideError();

    try {
      const formData = new FormData(this.form);
      const actionURL = this.form.getAttribute('action');

      const response = await fetch(actionURL, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify(Object.fromEntries(formData.entries())),
      });

      if (response.ok) {
        this.showSuccess();
      } else {
        throw new Error(`HTTP ${response.status}: ${response.statusText}`);
      }
    } catch (error) {
      console.error('Form submission error:', error);
      this.showError();
    } finally {
      this.setLoadingState(false);
    }
  }

  setLoadingState(isLoading) {
    const submitButton = this.form?.querySelector('button[type="submit"]');
    if (!submitButton) return;

    if (isLoading) {
      this.form.classList.add('is-loading');
      submitButton.setAttribute('disabled', 'disabled');
    } else {
      this.form.classList.remove('is-loading');
      submitButton.removeAttribute('disabled');
    }
  }

  showSuccess() {
    if (this.form) this.form.style.display = 'none';
    if (this.successState) this.successState.style.display = 'block';
    if (this.description) this.description.style.display = 'none';

    setTimeout(() => {
      this.form?.reset();
    }, 1000);
  }

  showError() {
    if (this.errorMessage) {
      this.errorMessage.style.display = 'block';
    }
  }

  hideError() {
    if (this.errorMessage) {
      this.errorMessage.style.display = 'none';
    }
  }

  handleBotpoisonFailure() {
    const submitButton = this.form?.querySelector('button[type="submit"]');

    if (this.errorMessage) {
      this.errorMessage.textContent =
        'Bot protection service unavailable. Please try again later.';
      this.errorMessage.style.display = 'block';
    }

    if (submitButton) {
      submitButton.setAttribute('disabled', 'disabled');
      submitButton.textContent = 'Service Unavailable';
    }
  }

  open() {
    document.body.classList.add('enquiry-modal--show');
  }

  close() {
    document.body.classList.remove('enquiry-modal--show');

    setTimeout(() => {
      if (this.form) {
        this.form.style.display = 'flex';
        this.form.reset();
      }
      if (this.successState) this.successState.style.display = 'none';
      if (this.description) this.description.style.display = 'block';
      this.hideError();
    }, 500);
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new EnquiryModal();
});
